import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import Keycloak from "keycloak-js";
import { firstValueFrom } from "rxjs";
import { AppRoutes } from "src/app/enums";
import { DBService } from "src/app/services/api/bi-service/api/db.service";
import { OnboardingSessionService } from "src/app/services/onboarding-session.service";
import { PRODUCT_BRAND } from "src/app/product";

export const onboardingGuard: CanActivateFn = async (_route, state) => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);
  const dbService = inject(DBService);
  const onboardingSessionService = inject(OnboardingSessionService);

  // Data source onboarding is a Talk BI flow; HouseClaw users never connect a database.
  if (
    inject(PRODUCT_BRAND).product === "houseclaw" ||
    !keycloak.authenticated ||
    onboardingSessionService.isDismissedForCurrentSession(keycloak) ||
    onboardingSessionService.isHandledForCurrentUser(keycloak)
  ) {
    return true;
  }

  try {
    const connections = await firstValueFrom(dbService.dbControllerGetConnectionsV1());
    if (connections.length > 0) {
      return true;
    }
  } catch (error) {
    console.error("Failed to verify datasource state for onboarding redirect:", error);
    return true;
  }

  return router.createUrlTree([AppRoutes.onboarding], {
    queryParams: {
      returnUrl: state.url !== "/" ? state.url : null,
    },
  });
};
